import qs from 'qs'
import i18n from '@signavio/i18n'
import { LegacyHint, PlaceholderTile, TextTile } from '@signavio/ui'
import { Nullable } from '@signavio/effektif-commons'
import { getBaseUrl } from '../../callApi'
import { useFileDownloadSecret } from '../../hooks'
import FileBase from './FileBase'
import { useFetchFile } from './useFetchFile'

type FileProps = {
  showImage?: boolean
  small?: boolean
  transparent?: boolean
  fileId: Nullable<string>
}

function File({ showImage, small, transparent, fileId }: FileProps) {
  const fileDownloadSecret = useFileDownloadSecret()
  const { file, loading, error } = useFetchFile(fileId)

  const src = `${getBaseUrl()}/files/${fileId}/stream${qs.stringify(
    { token: fileDownloadSecret },
    { addQueryPrefix: true }
  )}`

  if (loading) {
    return (
      <PlaceholderTile withHeader small={small} transparent={transparent} />
    )
  }

  if (error) {
    return (
      <TextTile small={small} transparent={transparent}>
        <LegacyHint inline danger small={small}>
          {i18n('Could not load file.')}
        </LegacyHint>
      </TextTile>
    )
  }

  if (!file) {
    return null
  }

  return (
    <FileBase
      src={src}
      file={file}
      showImage={showImage}
      small={small}
      transparent={transparent}
    />
  )
}

export default File
